import { defineMessages } from "react-intl";

const messages = defineMessages({
  contact: {
    id: "fileStorage.components.contact.contact",
    defaultMessage: `If issue persists contact the Apex Business Automation Team.`,
  },
});

export default messages;
